/**
 * 联系客服 / 帮助页(公开,无守卫)。
 *
 * 平台客服入口页:展示官方客服联系方式(邮箱 / 电话 / 官网 / 服务时间)+ 自助与争议处理指引。
 * 背景:微信支付服务商「分账」申报「PC 网站经营场景」需「客服入口页」;Footer「联系客服」链接至本页。
 * 联系方式与 Footer 合规展示契约(_shared C-2)一致:support@tianhengjinyuan.com / 19902065846。
 */

const SUPPORT_EMAIL = 'support@tianhengjinyuan.com';
const SUPPORT_PHONE = '19902065846';
const SUPPORT_SITE = 'https://workabilityshow.com';
const SUPPORT_HOURS = '周一至周日 9:00–21:00';

function ContactRow({
  label,
  value,
  href,
}: {
  label: string;
  value: string;
  href?: string;
}) {
  return (
    <div className="flex items-baseline justify-between gap-4 border-b border-border py-3 last:border-b-0">
      <span className="text-sm text-muted-foreground">{label}</span>
      {href ? (
        <a
          href={href}
          className="text-sm font-medium text-foreground hover:text-primary"
        >
          {value}
        </a>
      ) : (
        <span className="text-sm font-medium text-foreground">{value}</span>
      )}
    </div>
  );
}

export function CustomerServicePage() {
  return (
    <main
      data-testid="customer-service-screen"
      className="mx-auto w-full max-w-2xl px-4 py-8"
    >
      <h1 className="text-2xl font-semibold text-foreground">联系客服</h1>
      <p className="mt-2 text-sm leading-6 text-muted-foreground">
        如在使用「我行分享平台」过程中遇到任何问题,或对订单、退款、账号等有疑问,欢迎通过以下方式联系平台客服,我们将尽快为你处理。
      </p>

      <section className="mt-8">
        <h2 className="mb-1 text-xs uppercase tracking-wide text-muted-foreground">
          联系客服
        </h2>
        <div className="rounded-lg border border-border bg-card px-4">
          <ContactRow
            label="客服邮箱"
            value={SUPPORT_EMAIL}
            href={`mailto:${SUPPORT_EMAIL}`}
          />
          <ContactRow
            label="客服电话"
            value={SUPPORT_PHONE}
            href={`tel:${SUPPORT_PHONE}`}
          />
          <ContactRow
            label="官方网站"
            value="workabilityshow.com"
            href={SUPPORT_SITE}
          />
          <ContactRow label="服务时间" value={SUPPORT_HOURS} />
        </div>
      </section>

      <section className="mt-8">
        <h2 className="mb-2 text-xs uppercase tracking-wide text-muted-foreground">
          自助与争议处理
        </h2>
        <ul className="space-y-2 text-sm leading-6 text-foreground">
          <li>· 服务相关问题,可在「订单详情」中与卖家在线沟通。</li>
          <li>
            · 如需退款,可在订单进行中点击「申请取消订单」;卖家同意或平台仲裁后,款项将原路退回。
          </li>
          <li>
            · 协商不成的争议,可申请平台介入,平台将作为独立第三方依据规则作出处理。
          </li>
        </ul>
      </section>
    </main>
  );
}
